<template>
  <div
    class="flex-1 flex flex-col min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8 transition-all duration-300 ml-0 lg:ml-64"
  >
    <Header
      @company-selected="handleCompanySelected"
      @update-controllers-count="updateControllersCount"
      class="mb-6 text-base md:text-lg lg:text-xl"
    />

    <main class="flex flex-col gap-6">
      <CardCategorization v-bind="computedProps" class="rounded-xl shadow-lg" />

      <DomainMaturityCards :enterprise-id="selectedCompany._id" class="mt-2" />

      <ChartsDashboardDominios :enterprise-id="selectedCompany._id" />

      <!-- Gráficos lado a lado em telas grandes, empilhados em telas pequenas -->
      <div class="flex flex-col lg:flex-row gap-6">
        <!-- Gráfico de Barras -->
        <div class="flex-1 w-full lg:w-1/2 xl:w-2/5 mx-auto h-96">
          <div class="h-full">
            <ChartsBarTypeControl :enterprise-id="selectedCompany._id" />
          </div>
        </div>

        <!-- Gráfico de Capacidades Operacionais -->
        <div class="flex-1 w-full lg:w-1/2 xl:w-2/5 mx-auto h-96">
          <div class="h-full">
            <ChartsCapacidadesOperacionais
              v-if="selectedCompany._id"
              :enterprise-id="selectedCompany._id"
            />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CardCategorization from '@/components/ui/cards/CardCategorization.vue'
import Header from '@/components/layout/Header.vue'
import ChartsDashboardDominios from '@/components/ui/charts/ChartsDashboardDominios.vue'
import ChartsBarTypeControl from '../ui/charts/ChartsBarTypeControl.vue'
import { getControllersCount } from '@/services/security-controls/api.controllers'
import DomainMaturityCards from '@/components/ui/DomainMaturityCards.vue'
import ChartsCapacidadesOperacionais from '@/components/ui/charts/ChartCapacidadesOperacionais.vue'

export default {
  name: 'AdminDashboard',
  components: {
    Header,
    CardCategorization,
    ChartsDashboardDominios,
    ChartsBarTypeControl,
    DomainMaturityCards,
    ChartsCapacidadesOperacionais,
  },
  data() {
    return {
      showCadastro: false,
      showCadastroControles: false,
      controllersCount: 0,
      selectedCompany: {
        _id: '',
        EmpresaID: '',
        NomeEmpresa: '',
        totalControlesPorEmpresa: 0,
        QtdControlesImplementados: 0,
        QtdControlesParcial: 0,
        QtdControlesNaoImplementados: 0,
        NivelMaturidade: 0,
      },
      domainTitles: [
        'Defesa',
        'Resiliência',
        'Governança e Ecossistema',
        'Proteção',
      ],
    }
  },

  computed: {
    computedProps() {
      const EmpresaID = this.selectedCompany?._id
      return {
        totalControles: this.controllersCount,
        controleImplementado:
          this.selectedCompany?.QtdControlesImplementados ?? 0,
        controleParcial: this.selectedCompany?.QtdControlesParcial ?? 0,
        controleNaoImplementado:
          this.selectedCompany?.QtdControlesNaoImplementados ?? 0,
        controleNaoAplicavel:
          this.selectedCompany?.QtdControlesNaoAplicados ?? 0,

        nivelMaturidade:
          (((this.selectedCompany?.QtdControlesImplementados ?? 0) +
            (this.selectedCompany?.QtdControlesParcial ?? 0)) *
            100) /
          (this.controllersCount -
            (this.selectedCompany?.QtdControlesNaoAplicados ?? 0) || 1),
        temEmpresaID: !!EmpresaID,

        // Controles detalhados
        PhysicalControl: this.selectedCompany?.PhysicalControl ?? 0,
        PhysicalControlImplemented:
          this.selectedCompany?.PhysicalControlImplemented ?? 0,
        PhysicalControlNotApplicable:
          this.selectedCompany?.PhysicalControlNotApplicable ?? 0,
        PhysicalControlNotImplemented:
          this.selectedCompany?.PhysicalControlNotImplemented ?? 0,
        PhysicalControlPartiallyImplemented:
          this.selectedCompany?.PhysicalControlPartiallyImplemented ?? 0,

        FunctionalControlTypes:
          this.selectedCompany?.FunctionalControlTypes ?? 0,

        NivelMaturidade: this.selectedCompany?.NivelMaturidade ?? 0,

        OrganizationalControl: this.selectedCompany?.OrganizationalControl ?? 0,
        OrganizationalControlImplemented:
          this.selectedCompany?.OrganizationalControlImplemented ?? 0,
        OrganizationalControlNotApplicable:
          this.selectedCompany?.OrganizationalControlNotApplicable ?? 0,
        OrganizationalControlNotImplemented:
          this.selectedCompany?.OrganizationalControlNotImplemented ?? 0,
        OrganizationalControlPartiallyImplemented:
          this.selectedCompany?.OrganizationalControlPartiallyImplemented ?? 0,

        PeopleControl: this.selectedCompany?.PeopleControl ?? 0,
        PeopleControlImplemented:
          this.selectedCompany?.PeopleControlImplemented ?? 0,
        PeoplesControlNotApplicable:
          this.selectedCompany?.PeoplesControlNotApplicable ?? 0,
        PeopleControlNotImplemented:
          this.selectedCompany?.PeopleControlNotImplemented ?? 0,
        PeopleControlPartiallyImplemented:
          this.selectedCompany?.PeopleControlPartiallyImplemented ?? 0,

        QtdControlesImplementados:
          this.selectedCompany?.QtdControlesImplementados ?? 0,
        QtdControlesNaoImplementados:
          this.selectedCompany?.QtdControlesNaoImplementados ?? 0,
        QtdControlesParcial: this.selectedCompany?.QtdControlesParcial ?? 0,
        QtdControlesNaoAplicados:
          this.selectedCompany?.QtdControlesNaoAplicados ?? 0,

        TechnologicalControl: this.selectedCompany?.TechnologicalControl ?? 0,
        TechnologicalControlImplemented:
          this.selectedCompany?.TechnologicalControlImplemented ?? 0,
        TechnologicalControlNotApplicable:
          this.selectedCompany?.TechnologicalControlNotApplicable ?? 0,
        TechnologicalControlNotImplemented:
          this.selectedCompany?.TechnologicalControlNotImplemented ?? 0,
        TechnologicalControlPartiallyImplemented:
          this.selectedCompany?.TechnologicalControlPartiallyImplemented ?? 0,
      }
    },

    totalControlesPorEmpresa() {
      return (
        this.selectedCompany.QtdControlesImplementados +
        this.selectedCompany.QtdControlesParcial +
        this.selectedCompany.QtdControlesNaoImplementados
      )
    },
  },
  methods: {
    async updateControllersCount() {
      try {
        const response = await getControllersCount()
        this.controllersCount = response.count
      } catch (error) {
        console.error('Erro ao buscar a contagem de controles:', error)
      }
    },
    handleCompanySelected(company) {
      this.selectedCompany = { ...company }
    },
    toggleCadastro() {
      this.showCadastro = !this.showCadastro
    },
    toggleCadastroControles() {
      this.showCadastroControles = !this.showCadastroControles
    },
    handleUserClick() {
      this.updateControllersCount()
    },
  },
  mounted() {
    this.updateControllersCount()
    document.addEventListener('click', this.handleUserClick)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleUserClick)
  },
}
</script>
